import React from 'react';
import { graphql, StaticQuery } from 'gatsby';
import styled from 'styled-components';


const Container = styled.div<{ backgroundImage: string }>`
  background-image: ${({ backgroundImage }) => `url(${backgroundImage})`};
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
`;

const Kaffka = ({ className = '' }) => (
  <StaticQuery
    query={graphql`
      query {
        svg: file(name: { eq: "portfolioKaffka" }) {
          publicURL
        }
      }
    `}
    render={data => <Container backgroundImage={data.svg.publicURL} className={className} />}
  />
);


export default Kaffka;
